// extracted by mini-css-extract-plugin
module.exports = {"download":"Download_download__3zDoG","cards-grid":"Download_cards-grid__8EHbo"};